import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, Grid, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button } from "../../Button/Button";
import { isRefinerGroupEmpty } from "../ListsRefinerGroup";
import { Messages } from "../Messages";
import { RefinerGroupType } from "../RefinerGroup";
import { RefinerGroupDisplay } from "./RefinerGroupDisplay";
RefinerGroupList.defaultProps = { numOptionsShown: 3, disabled: false, clearOnDelete: false };
const classes = {
    root: "root",
    titleContainer: "titleContainer",
    titleText: "titleText",
    iconContainer: "iconContainer",
    divider: "divider"
};
const StyledDiv = styled("div")(({ theme }) => ({
    [`& .${classes.root}`]: {
        padding: "10px 15px"
    },
    [`& .${classes.titleContainer}`]: {
        flex: "1 1 auto"
    },
    [`& .${classes.titleText}`]: {
        fontSize: "18px",
        color: theme.palette.text.black
    },
    [`& .${classes.iconContainer}`]: {
        flex: "0 0 auto"
    },
    [`& .${classes.divider}`]: {
        marginTop: "2px"
    }
}));
/**
 * Refiner control
 * @param props @see RefinerGroupListProps
 */
export function RefinerGroupList(props) {
    const { numOptionsShown, refinerGroups } = props;
    const [refinerIsExpanded, setRefinerIsExpanded] = useState(allExpanded());
    useEffect(() => {
        setRefinerIsExpanded(allExpanded());
    }, [refinerGroups.length]);
    function onOptionChanged(refinerGroup, optionValue, isSelected) {
        props.onOptionIsSelectedChanged(refinerGroup.path, optionValue, isSelected);
    }
    function onDateRangeChange(refinerGroup, dateRange) {
        props.onDateRangeChange(refinerGroup.path, dateRange);
    }
    function allCollapsed() {
        const newRefinerIsExpanded = {};
        props.refinerGroups.forEach((group) => (newRefinerIsExpanded[group.path] = false));
        return newRefinerIsExpanded;
    }
    function allExpanded() {
        const newRefinerIsExpanded = {};
        props.refinerGroups.forEach((group) => (newRefinerIsExpanded[group.path] = true));
        return newRefinerIsExpanded;
    }
    const areAllCollapsed = () => Object.values(refinerIsExpanded).every((v) => v === false);
    const rows = refinerGroups.map((refinerGroup) => {
        const displayRefinerGroup = refinerGroup.refinerGroupType === RefinerGroupType.ListRefiner ? !isRefinerGroupEmpty(refinerGroup) : true;
        return (React.createElement(Grid, { item: true, className: "refiner-list-item", style: { display: displayRefinerGroup ? "contents" : "none" }, key: refinerGroup.name },
            React.createElement(RefinerGroupDisplay, { disabled: props.disabled, numOptionsShown: numOptionsShown ?? RefinerGroupList.defaultProps.numOptionsShown, onOptionSelectionChanged: (optionValue, isSelected) => {
                    onOptionChanged(refinerGroup, optionValue, isSelected);
                }, refinerGroup: refinerGroup, isExpanded: refinerIsExpanded[refinerGroup.path], setIsExpanded: (value) => setRefinerIsExpanded({ ...refinerIsExpanded, [refinerGroup.path]: value }), onDateSelectionChanged: (dateRange) => onDateRangeChange(refinerGroup, dateRange) })));
    });
    const expandCollapseAllGroups = () => {
        if (areAllCollapsed()) {
            setRefinerIsExpanded(allExpanded());
        }
        else {
            setRefinerIsExpanded(allCollapsed());
        }
    };
    const expandCollapseIcon = (React.createElement(Button, { iconButton: true, startIcon: areAllCollapsed() ? React.createElement(ExpandMoreIcon, null) : React.createElement(ExpandLessIcon, null), onClick: expandCollapseAllGroups, variant: "plain", rounded: true, "aria-label": Messages.EXPAND_COLLAPSE_REFINER.getMessage([areAllCollapsed() ? "More" : "Less"]), disabled: props.disabled }));
    return (React.createElement(StyledDiv, null,
        React.createElement(Grid, { container: true, direction: "column", className: classes.root, style: { opacity: props.disabled ? 0.5 : 1 } },
            React.createElement(Grid, { container: true, item: true },
                React.createElement(Grid, { item: true, className: classes.titleContainer },
                    React.createElement("span", { className: classes.titleText }, "Refiners")),
                React.createElement(Grid, { item: true, className: classes.iconContainer }, expandCollapseIcon)),
            React.createElement(Divider, { className: classes.divider }),
            rows)));
}
